import { render, staticRenderFns } from "./ReturnabilityByService.vue?vue&type=template&id=12e4a61c&scoped=true"
import script from "./ReturnabilityByService.vue?vue&type=script&lang=js"
export * from "./ReturnabilityByService.vue?vue&type=script&lang=js"
import style0 from "./ReturnabilityByService.vue?vue&type=style&index=0&id=12e4a61c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e4a61c",
  null
  
)

export default component.exports